import { defineComponent as i, useTemplateRef as l, ref as c, onMounted as u, nextTick as f, openBlock as p, createElementBlock as d, createElementVNode as s, normalizeClass as m, renderSlot as v } from "vue";
const b = /* @__PURE__ */ i({
  __name: "ScrollingContent",
  setup(g) {
    const t = l("text"), n = l("container"), o = c(!1), a = () => {
      !n.value || !t.value || (o.value = t.value.scrollWidth > n.value.clientWidth);
    };
    return u(() => {
      f(() => a());
    }), (r, e) => (p(), d("div", {
      ref_key: "container",
      ref: n,
      class: "relative isolate overflow-hidden whitespace-nowrap"
    }, [
      e[0] || (e[0] = s("span", { class: "from-bg-static-success-mid absolute inset-y-0 left-0 z-[1] w-4 bg-gradient-to-r to-transparent" }, null, -1)),
      e[1] || (e[1] = s("span", { class: "from-bg-static-success-mid absolute inset-y-0 right-0 z-[1] w-4 bg-gradient-to-l to-transparent" }, null, -1)),
      s("p", {
        ref_key: "text",
        ref: t,
        class: m(["inline-block px-4", {
          "animate-[coupon-scroll_10s_ease-in-out_infinite]": o.value
        }])
      }, [
        v(r.$slots, "default")
      ], 2)
    ], 512));
  }
});
export {
  b as default
};
